<template>
  <li
    :class="className"
    v-on="$listeners"
    @click="clickHandler"
  >
    <slot />
  </li>
</template>

<script>
const name = 'ten-dropdown-item';
export default {
  name,
  inject: ['tenDropdown'],
  props: {
    /**
     * item 的唯一标识
     */
    index: [String, Number],
    /**
     * 是否禁用
     */
    disabled: Boolean,
    /**
     * 显示分割线
     */
    divided: Boolean,
  },
  computed: {
    className() {
      return [
        'ten-dropdown-item',
        'ten-dropdown__content-item',
        {
          'ten-dropdown__content-item--disabled': this.disabled,
          'ten-dropdown__content-item--divided': this.divided,
        },
      ];
    },
  },
  methods: {
    clickHandler() {
      if (this.disabled) return;
      this.tenDropdown.$emit('dropdown-item:click', this.index);
    },
  },
};
</script>
